module.exports = __webpack_public_path__ + "static/media/paypal_icon.26d04310.svg";